<template>
    <div v-if="notes" class="note-cell-renderer">
        <b-button variant="link" size="xs" @click="showNotes">
            Show
        </b-button>
        <modal
            :id="noteModalID"
            title="Guest Transaction Note"
            hide-footer
        >
            {{ notes }}
        </modal>
    </div>
</template>

<script>
import Modal from '../../generic/modal/modal.vue';
export default {
    name: 'noteCellRendererFramework',
    components: { Modal },
    computed: {
        notes() {
            return this.params.value;
        },
        noteModalID() {
            const { data, value } = this.params;
            if (value)
                return `guest-transaction-modal-${data.id}`;
            return ''
        },
    },
    methods: {
        showNotes() {
            this.$bvModal.show(this.noteModalID);
        }
    }
};
</script>

<style lang="scss" scoped>
.note-cell-renderer {
    button {
        font-size: 12px;
        padding: 0;
    }
}
</style>